import React, { FC } from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { BtScreen } from '@linqpal/components/src/ui'
import { IconCloseSquare, Left } from '../../../../assets/icons'
import { observer } from 'mobx-react'

interface IProps {
  title: string
  onBack?: () => void
  onClose?: () => void
  children: (JSX.Element | null)[]
}

export const PaymentStepContainer: FC<IProps> = observer(
  ({ title, onBack, onClose, children }) => {
    return (
      <BtScreen
        title={title}
        titleCentered
        rightTitleAction={
          !!onClose && (
            <TouchableOpacity style={styles.button} onPress={onClose}>
              <IconCloseSquare width={12} height={12} />
            </TouchableOpacity>
          )
        }
        leftTitleAction={
          !!onBack && (
            <TouchableOpacity style={styles.button} onPress={onBack}>
              <Left width={12} height={12} fill={'#335C75'} />
            </TouchableOpacity>
          )
        }
      >
        <View style={styles.contentWrapper}>{children}</View>
      </BtScreen>
    )
  },
)

const styles = StyleSheet.create({
  button: {
    borderColor: '#E6EBEE',
    borderRadius: 6,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
  },
  contentWrapper: {
    maxWidth: 500,
    alignSelf: 'center',
    alignItems: 'center',
  },
})
